var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildMeetAnalyticCsvRow, buildMeetAnalyticTableColumns, buildMeetAnalyticTableData, meetAnalyticTableColgroup } from '@web/components/Apps/Meet/utils/meetAnalyticTableUtils';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useMeetAppsSearchNavigation } from '@web/utility/searchMeetingsNavigation';
import { InsightTypeEnum, MEETINGS_BY_WHEN_KEYS } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
var I18N = 'app.apps.meeting.meetingsByWhen';
var WHEN_LABEL_KEYS = {
    workHours: "".concat(I18N, ".rows.workHours"),
    afterHours: "".concat(I18N, ".rows.afterHours"),
    earlyMorning: "".concat(I18N, ".rows.earlyMorning"),
    lateEvening: "".concat(I18N, ".rows.lateEvening")
};
var MeetingsByWhen = function () {
    var t = useTranslation().t;
    var navigateToMeetSearch = useMeetAppsSearchNavigation();
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var _b = trpc.meetingsByWhenAnalytic.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: user,
        orgUnitId: orgUnit
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showTeamMetrics = user == null;
    var tableOptions = { includeTeamMetrics: showTeamMetrics };
    var rowsByKey = Object.fromEntries(data.rows.map(function (row) { return [row.key, row]; }));
    var tableData = buildMeetAnalyticTableData({
        keys: MEETINGS_BY_WHEN_KEYS,
        rowsByKey: rowsByKey,
        getLabel: function (key) { return t(WHEN_LABEL_KEYS[key]); },
        navigateToMeetSearch: navigateToMeetSearch,
        includeTeamMetrics: showTeamMetrics
    });
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t("".concat(I18N, ".title")), description: "widgetTitleDescriptions.apps.meetingsByWhenAnalytic", insightType: InsightTypeEnum.meetingsByWhenAnalytic, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t("".concat(I18N, ".title")), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, MEETINGS_BY_WHEN_KEYS.map(function (key) {
                                    return buildMeetAnalyticCsvRow(t, I18N, t(WHEN_LABEL_KEYS[key]), rowsByKey[key], tableOptions);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(Table, { columns: buildMeetAnalyticTableColumns(t, I18N, tableOptions), data: isInsightsDataEmpty(data) ? [] : tableData, columnColStyles: meetAnalyticTableColgroup(tableOptions), tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top" })] }));
};
export default MeetingsByWhen;
